import { addresses } from '../../addresses'
import abi from './abi'

export const JSONExtensionRegistry = {
  abi,
  address: addresses.JSON_EXTENSION_REGISTRY,
} as const
